import { $$ } from '@utils';

function init() {
  setYoutubeVideoWithCookieOrNot();
}

/**
 * Function to set src of youtube videos as youtube.com or youtube-nocookie.com
 * This enables the Privacy Enhanced Mode of the YouTube embedded player.
 * It prevents the use of views of embedded YouTube content from influencing
 * the viewer’s browsing experience on YouTube.
 *
 * Set document.cookie = '__cppr_yt=true'; or document.cookie = '__cppr_yt=false';
 * at the top of the function to test functionality and see how youtube url changes
 *
 */
function setYoutubeVideoWithCookieOrNot() {
  $$('[data-au-youtube-video]').forEach((ytVideo) => {
    if (document.cookie.indexOf('__cppr_yt=true') === -1) {
      ytVideo.dataset.auYoutubeVideo = ytVideo.dataset.auYoutubeVideo.replace('youtube.com', 'youtube-nocookie.com');
    }

    ytVideo.setAttribute('src', ytVideo.dataset.auYoutubeVideo);
  });
}

export default { init };
